/**
 * Onboarding Banner Component
 * "We have a new Section!" eye-catcher banner
 * Shows once per user
 */

const React = require('react');
const PropTypes = require('prop-types');
require('./OnboardingBanner.css');

const EyeIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 4C5.5 4 2 10 2 10s3.5 6 8 6 8-6 8-6-3.5-6-8-6z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <circle
      cx='10'
      cy='10'
      r='2.5'
      stroke='currentColor'
      strokeWidth='2'
      fill='none'
    />
  </svg>
);

/**
 * OnboardingBanner component
 * @param {Object} props
 * @param {Function} props.onDismiss - Callback when banner is dismissed
 */
const OnboardingBanner = ({ onDismiss }) => {
  return (
    <div className='onboarding-banner'>
      <div className='onboarding-banner__content'>
        <div className='onboarding-banner__icon'>
          <EyeIcon />
        </div>
        <span className='text-style-short-lables-14-semi-bold onboarding-banner__text'>
          We have a new Section!
        </span>
      </div>
      <button
        className='onboarding-banner__close'
        onClick={onDismiss}
        aria-label='Dismiss banner'
      >
        <svg
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 4L4 12M4 4l8 8'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </button>
    </div>
  );
};

OnboardingBanner.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

module.exports = OnboardingBanner;
